import { createAction as makeActionCreator } from 'redux-actions';

import api from '../api/';
import { handleError, getErrorMessage } from './errors';

export const openCancelReservationScreen = makeActionCreator('OPEN_CANCEL_RESERVATION_SCREEN');
export const closeCancelReservationScreen = makeActionCreator('CLOSE_CANCEL_RESERVATION_SCREEN');

export const fetchingReservation = makeActionCreator('FETCHING_RESERVATION');
export const fetchingReservationFailed = makeActionCreator('FETCHING_RESERVATION_FAILED');
export const reservationReceived = makeActionCreator('RESERVATION_RECEIVED');

export const cancellingReservation = makeActionCreator('CANCELLING_RESERVATION');
export const cancellingReservationFailed = makeActionCreator('CANCELLING_RESERVATION_FAILED');
export const reservationCancelled = makeActionCreator('RESERVATION_CANCELLED');

export const reservationAlreadyCancelled = makeActionCreator('RESERVATION_ALREADY_CANCELLED');

export const triggerCloseCancelReservationScreen = dispatch => () => dispatch(closeCancelReservationScreen());

export const fetchReservation = dispatch => (reservationCode) => {
  dispatch(fetchingReservation());
  api.fetchReservation({ reservationCode })
  .then((data) => {
    if (data.status === 5) {
      dispatch(reservationAlreadyCancelled(data));
    } else {
      dispatch(reservationReceived(data));
    }
  })
  .catch((error) => {
    dispatch(handleError)(fetchingReservationFailed(getErrorMessage(error)));
  });
};

export const cancelReservation = dispatch => (reservationId, cbAction) => {
  dispatch(cancellingReservation());
  api.cancelReservation({ reservationId })
  .then(data => dispatch(reservationCancelled(data)))
  .then(() => {
    if (cbAction) {
      cbAction();
    }
  })
  .catch((error) => {
    dispatch(handleError)(cancellingReservationFailed(getErrorMessage(error)));
  });
};



// WEBPACK FOOTER //
// ./src/actions/cancelling.js